<template>
  <div class="menu" :class="[{active: isActive}]" ref="menuRef">
    <div class="menu__actions" v-if="user">
      <div class="menu__actions-inner">
        <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'wishlist' })">
          <img src="@icons/wishlistIcon.svg" alt="wishlist">
          <div class="menu__actions-quantity">{{ productsInWishlistQuantity }}</div>
        </router-link>
        <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'cart' })">
          <img src="@icons/cartIcon.svg" alt="cart">
          <div class="menu__actions-quantity">{{ productsInCartQuantity }}</div>
        </router-link>
        <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'profile' })">
          <img src="@icons/accountIcon.svg" alt="account">
        </router-link>
      </div>
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'profile-topup' })" class="menu__actions-balance">
        <img src="@icons/currency.svg" alt="currency">
        <p>{{ userBalance }}</p>
      </router-link>
    </div>
    <div class="menu__auth" v-else>
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'login' })" class="menu__auth-login">{{ t('buttons.login') }}</router-link>
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'register' })" class="menu__auth-reg">
        {{ t('buttons.createAcc') }}
        <img src="@icons/registerArrow.svg" alt="register">
      </router-link>
    </div>
    <nav class="menu__nav">
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'store', params: { category: 'bundles' } })" class="menu__nav-item">Bundles</router-link>
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'store', params: { category: 'scripts' } })" class="menu__nav-item">Scripts</router-link>
      <router-link @click="closeModal" :to="translations.i18nRoute({ name: 'store', params: { category: 'templates' } })" class="menu__nav-item">Templates</router-link>
    </nav>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useAuthStore} from "@/stores/auth.js";
import translations from "@/core/helpers/translations.js";
import {useCartStore} from "@/stores/cart.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import {onClickOutside} from "@vueuse/core";

const {t} = useI18n()
const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()

const props = defineProps({
  isActive: Boolean,
  categories: Array,
})
const emit = defineEmits(['close-modal'])

const closeModal = () => {
  emit('close-modal');
}

const menuRef = ref(null)
onClickOutside(menuRef, () => closeModal())

const userBalance = computed(() => {
  return authStore.user ? authStore.user.balance.amount : 0
})

const productsInCartQuantity = computed(() => {
  return cartStore.currentOrder.orderProducts ? cartStore.currentOrder.orderProducts.edges.length : 0
})
const productsInWishlistQuantity = computed(() => {
  return wishlistStore.wishlist.products ? wishlistStore.wishlist.products.edges.length : 0
})

const user = computed(() => {
  return authStore.user
})
</script>

<style lang="scss" scoped>
.menu {
  cursor: default;
  display: none;
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  width: 300px;
  height: 100vh;
  background-color: $white;
  padding: 40px 40px;
  visibility: hidden;
  transform: translateX(100%);
  transition: transform 0.3s, visibility 0s 0.3s;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  border-left: 1px solid #E5E5E5;
  box-shadow: 0 4px 11.6px 0 rgba(0, 0, 0, 0.20);

  &.active {
    visibility: visible;
    transform: translateX(0);
    transition: transform 0.3s;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 15px;

    &-balance {
      display: flex;
      align-items: center;
      gap: 5px;

      & img {
        width: 30px;
      }

      & p {
        color: #2B3044;
        font-weight: 500;
      }
    }

    &-inner {
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-items: center;

      & a {
        position: relative;
      }
    }

    &-quantity {
      position: absolute;
      top: -15px;
      right: -15px;
      background-color: #5f9ffe;
      border-radius: 50%;
      width: 23px;
      aspect-ratio: 1;
      display: grid;
      place-items: center;

      font-size: 16px;
      font-weight: 700;
      color: $white;
    }
  }

  &__nav {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &-item {
      transition: 0.2s;
      color: #2B3044;
      font-size: 20px;
      font-weight: 500;

      &:hover {
        color: #1e2336;
      }
    }
  }
}

@media (max-width: 1000px) {
  .menu {
    display: flex;
  }
}
</style>